import apiClient from '../axiosInstance';

import { API_BASE_ADDRESS } from '../api';

const receiptService = (action: any) => {
  return {
    getReceiptData: () =>
      apiClient.get(`${API_BASE_ADDRESS}/mypage/member/receiptData`, {
        params: {
          member_id: action.memberId,
        },
      }),
    getReceipt: () =>
      apiClient.get(`${API_BASE_ADDRESS}/mypage/member/receipt`, {
        params: {
          member_id: action.memberId,
          target_month: action.targetMonth,
          payment_date: action.paymentDate,
        },
      }),
    updateReceipt: () =>
      apiClient
        .put(
          `${API_BASE_ADDRESS}/mypage/member/receipt`,
          {
            target_month: action.targetMonth,
            payment_date: action.paymentDate,
            recipient_name: action.recipientName,
            clause_title: action.clauseTitle,
          },
          {
            params: {
              member_id: action.memberId,
            },
          },
        )
        // ios-safari
        .then((res) => {
          if (res.data) {
            window.location.href = res.data;
          }
          return res;
        }),
  };
};

export default receiptService;
